/* eslint-disable max-len */

import { Provider } from '@dataTypes/provider.types'

export const MOCK_PROVIDERS: Provider[] = [
  {
    provider_id: 'mock-provider-1',
    user_id: 'mock-user-1',
    clinic_id: 'mock-clinic-1',
    first_name: 'John',
    middle_name: 'Michael',
    last_name: 'Smith',
    username: 'jsmith',
    gender: 'Male',
    date_of_birth: '1985-05-15',
    pronouns: 'He/Him',
    marital_status: 'Married',
    address: '123 Main Street',
    city: 'New York',
    state: 'NY',
    zip: '10001',
    cellphone: '+15551234567',
    email: 'john.smith@example.com',
    home_number: '+15551234568',
    work_contact: '+15551234569',
    state_license_number: 'NY123456',
    state_where_licensed_issued: 'New York',
    state_license_expiry: '2025-12-31',
    employment_type: 'Full-Time',
    provider_color: {
      header: '#185dd8',
      background: '#b1d5fb',
      text_color: '#112850',
      label: 'Blue',
    },
    created_by: 'system',
    updated_by: 'system',
    workingHours: [
      {
        day_of_week: 'Monday',
        start_time: '09:00',
        end_time: '17:00',
      },
      {
        day_of_week: 'Tuesday',
        start_time: '09:00',
        end_time: '17:00',
      },
      {
        day_of_week: 'Wednesday',
        start_time: '09:00',
        end_time: '17:00',
      },
      {
        day_of_week: 'Thursday',
        start_time: '09:00',
        end_time: '17:00',
      },
      {
        day_of_week: 'Friday',
        start_time: '09:00',
        end_time: '17:00',
      },
    ],
    shift_start_time: '09:00',
    shift_end_time: '17:00',
    is_hidden: false,
    work_role: 'Dentist',
    date_time_created_at: '2024-01-01T00:00:00Z',
    date_time_updated_at: '2024-01-01T00:00:00Z',
    operatory_rooms: 'Room 1, Room 2',
    work_status: 'Active',
    same_working_hours: true,
    last_login: '2026-04-01T14:30:00.000Z',
  },
  {
    provider_id: 'mock-provider-2',
    user_id: 'mock-user-2',
    clinic_id: 'mock-clinic-1',
    first_name: 'Sarah',
    middle_name: 'Elizabeth',
    last_name: 'Johnson',
    username: 'sjohnson',
    gender: 'Female',
    date_of_birth: '1990-08-22',
    pronouns: 'She/Her',
    marital_status: 'Single',
    address: '456 Oak Avenue',
    city: 'Los Angeles',
    state: 'CA',
    zip: '90001',
    cellphone: '+15559876543',
    email: 'sarah.johnson@example.com',
    employment_type: 'Part-Time',
    provider_color: {
      header: '#5f21ca',
      background: '#e5dcff',
      text_color: '#270f38',
      label: 'Purple',
    },
    created_by: 'system',
    updated_by: 'system',
    workingHours: [
      {
        day_of_week: 'Monday',
        start_time: '10:00',
        end_time: '14:00',
      },
      {
        day_of_week: 'Wednesday',
        start_time: '10:00',
        end_time: '14:00',
      },
      {
        day_of_week: 'Friday',
        start_time: '10:00',
        end_time: '14:00',
      },
    ],
    shift_start_time: '10:00',
    shift_end_time: '14:00',
    is_hidden: false,
    work_role: 'Hygienist',
    date_time_created_at: '2024-01-02T00:00:00Z',
    date_time_updated_at: '2024-01-02T00:00:00Z',
    operatory_rooms: 'Room 3',
    work_status: 'Active',
    same_working_hours: true,
    last_login: '2026-04-02T09:15:00.000Z',
  },
  {
    provider_id: 'mock-provider-3',
    user_id: 'mock-user-3',
    clinic_id: 'mock-clinic-1',
    first_name: 'David',
    last_name: 'Williams',
    username: 'dwilliams',
    gender: 'Male',
    date_of_birth: '1988-03-10',
    pronouns: 'He/Him',
    address: '789 Pine Street',
    city: 'Chicago',
    state: 'IL',
    zip: '60601',
    cellphone: '+15555555555',
    email: 'david.williams@example.com',
    state_license_number: 'IL789012',
    state_where_licensed_issued: 'Illinois',
    employment_type: 'Full-Time',
    provider_color: {
      header: '#5d9310',
      background: '#e4f0d0',
      text_color: '#19250e',
      label: 'Green',
    },
    created_by: 'system',
    updated_by: 'system',
    workingHours: [
      {
        day_of_week: 'Monday',
        start_time: '08:00',
        end_time: '16:00',
      },
      {
        day_of_week: 'Tuesday',
        start_time: '08:00',
        end_time: '16:00',
      },
      {
        day_of_week: 'Wednesday',
        start_time: '08:00',
        end_time: '16:00',
      },
      {
        day_of_week: 'Thursday',
        start_time: '08:00',
        end_time: '16:00',
      },
      {
        day_of_week: 'Friday',
        start_time: '08:00',
        end_time: '16:00',
      },
    ],
    shift_start_time: '08:00',
    shift_end_time: '16:00',
    is_hidden: false,
    work_role: 'Dentist',
    date_time_created_at: '2024-01-03T00:00:00Z',
    date_time_updated_at: '2024-01-03T00:00:00Z',
    operatory_rooms: 'Room 4, Room 5',
    work_status: 'Active',
    same_working_hours: true,
    last_login: '2026-03-28T16:45:00.000Z',
  },
  {
    provider_id: 'mock-provider-4',
    user_id: 'mock-user-4',
    clinic_id: 'mock-clinic-1',
    first_name: 'Emily',
    middle_name: 'Rose',
    last_name: 'Brown',
    username: 'ebrown',
    gender: 'Female',
    date_of_birth: '1992-11-05',
    pronouns: 'She/Her',
    marital_status: 'Married',
    address: '321 Elm Street',
    city: 'Houston',
    state: 'TX',
    zip: '77001',
    cellphone: '+15554443333',
    email: 'emily.brown@example.com',
    employment_type: 'Part-Time',
    provider_color: {
      header: '#ffa500',
      background: '#ffe6cc',
      text_color: '#663300',
      label: 'Orange',
    },
    created_by: 'system',
    updated_by: 'system',
    workingHours: [
      {
        day_of_week: 'Tuesday',
        start_time: '13:00',
        end_time: '17:00',
      },
      {
        day_of_week: 'Thursday',
        start_time: '13:00',
        end_time: '17:00',
      },
      {
        day_of_week: 'Saturday',
        start_time: '09:00',
        end_time: '13:00',
      },
    ],
    shift_start_time: '13:00',
    shift_end_time: '17:00',
    is_hidden: false,
    work_role: 'Assistant',
    date_time_created_at: '2024-01-04T00:00:00Z',
    date_time_updated_at: '2024-01-04T00:00:00Z',
    operatory_rooms: 'Room 1',
    work_status: 'Active',
    same_working_hours: false,
    last_login: '2026-04-03T11:00:00.000Z',
  },
  {
    provider_id: 'mock-provider-5',
    user_id: 'mock-user-5',
    clinic_id: 'mock-clinic-1',
    first_name: 'Michael',
    last_name: 'Davis',
    username: 'mdavis',
    gender: 'Male',
    date_of_birth: '1987-07-18',
    pronouns: 'He/Him',
    address: '654 Maple Drive',
    city: 'Phoenix',
    state: 'AZ',
    zip: '85001',
    cellphone: '+15553332222',
    email: 'michael.davis@example.com',
    state_license_number: 'AZ345678',
    state_where_licensed_issued: 'Arizona',
    state_license_expiry: '2026-06-30',
    employment_type: 'Full-Time',
    provider_color: {
      header: '#d8352a',
      background: '#ffcbc8',
      text_color: '#470c08',
      label: 'Red',
    },
    created_by: 'system',
    updated_by: 'system',
    workingHours: [
      {
        day_of_week: 'Monday',
        start_time: '09:00',
        end_time: '18:00',
      },
      {
        day_of_week: 'Tuesday',
        start_time: '09:00',
        end_time: '18:00',
      },
      {
        day_of_week: 'Wednesday',
        start_time: '09:00',
        end_time: '18:00',
      },
      {
        day_of_week: 'Thursday',
        start_time: '09:00',
        end_time: '18:00',
      },
      {
        day_of_week: 'Friday',
        start_time: '09:00',
        end_time: '18:00',
      },
    ],
    shift_start_time: '09:00',
    shift_end_time: '18:00',
    is_hidden: false,
    work_role: 'Dentist',
    date_time_created_at: '2024-01-05T00:00:00Z',
    date_time_updated_at: '2024-01-05T00:00:00Z',
    operatory_rooms: 'Room 2, Room 3',
    work_status: 'Active',
    same_working_hours: true,
    last_login: '2026-04-03T20:00:00.000Z',
  },
]

/** Subset for Provider Management table — frontend-only development */
export const PROVIDER_MANAGEMENT_DEV_MOCKS: Provider[] = [
  MOCK_PROVIDERS[0],
  MOCK_PROVIDERS[1],
  {
    ...MOCK_PROVIDERS[3],
    work_status: 'Inactive',
  },
]
